<template>
  <el-submenu v-if="hasChildren(item)" :index="item.path">
    <template slot="title">
      <Item v-if="item.meta" :icon="item.meta.icon" :title="item.title" :grade="item.grade"/>
    </template>
    <template v-for="(subItem, subIndex) in item.children">
      <SidebarItem :item="subItem" :key="subItem.path" :index="subIndex.toString()"/>
    </template>
  </el-submenu>
  <el-menu-item-group v-else-if="hasChildrenGroup(item)" :index="item.path">
    <template slot="title">
      <Item v-if="item.meta" :icon="item.meta.icon" :title="item.title" :grade="item.grade"/>
    </template>
    <template v-for="(subItem, subIndex) in item.children">
      <SidebarItem :item="subItem" :key="subItem.path" :index="subIndex.toString()"/>
    </template>
  </el-menu-item-group>
  <el-menu-item v-else-if="item.meta.menuType == 'C'" :index="item.path" :route="item">
    <Item v-if="item.meta" :icon="item.meta.icon" :title="item.title" :grade="item.grade"/>
  </el-menu-item>
</template>

<script>
import Item from './item'

export default {
  name: 'SidebarItem',
  components: {Item},
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    // 注意这里index是字符型
    index: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    hasChildren(node) {
      if (!node.children) {
        return false
      }
      return (node.children.length > 0 && node.meta.menuType == "M" && !node.meta.group)
    },
    hasChildrenGroup(node) {
      if (!node.children) {
        return false
      }
      return (node.children.length > 0 && node.meta.menuType == "M" && node.meta.group)
    },
  }
}
</script>
